<template>
  <div class="no-permission-page">
    <van-empty description="当前账号没有可访问的页面权限">
      <van-button type="primary" round @click="goLogin">返回登录页</van-button>
    </van-empty>
  </div>
</template>

<script>
export default {
  name: 'NoPermissionPage',
  methods: {
    goLogin() {
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('username');
      this.$router.replace('/login');
    }
  }
};
</script>

<style scoped>
.no-permission-page {
  min-height: calc(100vh - 46px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fa;
  padding: 24px;
}
</style>
